<style lang="scss" scoped></style>

<template>
    <div class="reseller-password-reset">
        <div class="container">
            <div class="row justify-center">
                <div class="md:w-1/2 lg:w-5/12 w-full">
                    <div class="lg:px-20">
                        <div class="text-center">
                            <h1 class="h4 mb-8">{{ translations.reset_title }}</h1>
                            <p class="mb-40">{{ translations.reset_description }}</p>
                        </div>

                        <el-form class="mb-24" @submit="submit" :loading="loading" :success="success" :error="server_error" button-class="btn btn-green btn-lg btn-rounded w-full mt-8 font-bold" :submit-text="translations.reset_button">
                            <el-input v-model="formData.password" type="password" :rules="{ required: true, min: 8, regex: /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/ }" :label="translations.password_field" class="mb-16"></el-input>
                            <el-input v-model="repeatPassword" type="password" :rules="{ required: true, is: formData.password, min: 8, regex: /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/ }" :label="translations.password_repeat_field" class="mb-16"></el-input>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import hasForm from "@mixins/components/has-form";

export default {
    name: "Ui.ResellerPasswordReset",

    mixins: [hasForm],

    props: {
        translations: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            formData: {
                email: "",
                password_reset_token: "",
                password: "",
            },
            repeatPassword: ""
        };
    },

    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get("email");
        const token = urlParams.get("token");

        if (email != null) {
            this.formData.email = email;
        }

        if (token != null) {
            this.formData.password_reset_token = token;
        }
    },

    methods: {
        submit() {
            this.beforeSubmit();

            axios
                .post("/api/reset-password", this.formData)
                .then(response => {
                    this.handleSuccess();
                    window.location = '/login?action=password-changed'
                })
                .catch(e => this.handleError(e));
        }
    }
};
</script>
